import './ContentWrapper.scss';

import * as React from 'react';

type Props = {
  children?: React.ReactNode;
};

export default function ContentWrapper({ children }: Props) {
  return <div className="ContentWrapper">{children}</div>;
}
